<app-page-header [isCurveGray]="true" header="{{language.fmenu3}}" backgroundPath="assets/images/lead/default.png">
</app-page-header>
<section class="investment--container">
    <div class="container">
        <header class="heading">
            <h1 class="topic-title h4">{{language.p2title}}</h1>
        </header>
        <div class="row">
            <div class="col-lg-6">
                <div class="topic--target">
                    <app-collapse-card header={{language.p2titlelbox}}>
                        <div class="topic--menu">
                            <app-icon-button [routerLink]="['/calculate']" (click)="setMenu('มือใหม่หัดลงทุน')" routerLinkActive="router-link-active" label={{language.p2titlelboxmenu1}} icon="assets/images/icon/plan/beginer.png" iconActive="assets/images/icon/plan/beginer-active.png"></app-icon-button>
                            <app-icon-button [routerLink]="['/calculate']" (click)="setMenu('เพื่อเป้าหมาย')" routerLinkActive="router-link-active" label={{language.p2titlelboxmenu2}} icon="assets/images/icon/plan/target.png" iconActive="assets/images/icon/plan/target-active.png"></app-icon-button>
                            <app-icon-button [routerLink]="['/calculate']" (click)="setMenu('เพื่อเกษียณ')" routerLinkActive="router-link-active" label={{language.p2titlelboxmenu3}} icon="assets/images/icon/plan/icon-retirement@2x.png" iconActive="assets/images/icon/plan/icon-tax-new-white@2x.png"></app-icon-button>
                        </div>
                    </app-collapse-card>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="topic--risk">
                    <app-collapse-card header={{language.p2titlerbox}}>
                        <div class="topic--menu">
                            <app-icon-button (click)="onSelectRisk('low')" [active]="riskLevel === 'low'" label={{language.p2titlerboxmenu1}} icon="assets/images/icon/risk/low@2x.png" iconActive="assets/images/icon/risk/low_@2x.png" activeBackground="#0EAD43"></app-icon-button>
                            <app-icon-button (click)="onSelectRisk('med')" [active]="riskLevel === 'med'" label={{language.p2titlerboxmenu2}} icon="assets/images/icon/risk/medium@2x.png" iconActive="assets/images/icon/risk/medium_@2x.png"></app-icon-button>
                            <app-icon-button (click)="onSelectRisk('high')" [active]="riskLevel === 'high'" label={{language.p2titlerboxmenu3}} activeBackground="#E64646" icon="assets/images/icon/risk/high@2x.png" iconActive="assets/images/icon/risk/high_@2x.png"></app-icon-button>
                        </div>
                    </app-collapse-card>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 col-sm-12">
                <div class="topic--type">
                    <app-collapse-card header={{language.p2titlecbox}}>
                        <app-swiper>
                            <div *ngFor="let item of sectionList; let sectionIndex = index" class="swiper-slide">
                                <app-icon-button [icon]="item.icon" [iconActive]="item.activeIcon" [active]="sectionIndex===selectedIndex" [label]="item.title" (click)="onSelectedContent(item.content,sectionIndex)"></app-icon-button>
                            </div>
                        </app-swiper>
                    </app-collapse-card>
                </div>
            </div>
        </div>

    </div>
</section>


<section class="content--template">
    <div *ngIf="selectedType === 'filter'" class="container">
        <ng-container *ngTemplateOutlet="fundList"></ng-container>
    </div>
    <div *ngIf="selectedType === 'risk'" class="container">
        <ng-container *ngTemplateOutlet=" risk"></ng-container>
    </div>
    <div *ngIf="selectedType === 'recommend'" class="container">
        <ng-container *ngTemplateOutlet=" fundList"></ng-container>
    </div>
</section>

<ng-template #fundList>
    <app-fund-list [header]="selectedContent.header" [description]="selectedContent.description" [fundList]="filterFundList" [totalPage]="totalPage" [currentPage]="currentPage" (currentPageChange)="pageChange($event)"></app-fund-list>
</ng-template>


<ng-template #risk>
    <!-- <app-fund-risk ></app-fund-risk> -->
    <section class="fund-risk--intro">
        <header>
            <h3 class="topic-title">
                <span rel="border-circle">
          <ng-container [ngSwitch]="true">
            <ng-container *ngSwitchCase="riskLevelName ===  'ความเสี่ยงต่ำ'  || riskLevelName ===  'Low Risk'">
              <img src="assets/images/icon/risk/low_@2x.png" alt="low" />
            </ng-container>
            <ng-container *ngSwitchCase="riskLevelName ===  'ความเสี่ยงปานกลาง'  || riskLevelName ===  'Moderate Risk'">
              <img src="assets/images/icon/risk/medium-small_@2x.png" alt="low" />
            </ng-container>
            <ng-container *ngSwitchCase="riskLevelName ===  'ความเสี่ยงสูง' || riskLevelName ===  'High Risk'">
              <img src="assets/images/icon/risk/high_@2x.png" alt="low" />
            </ng-container>
          </ng-container>
        </span>
                <span class="text" id="fund-cate-name">{{language.fundtitlerisk}} : {{riskLevelName}}</span>
            </h3>
        </header>
        <div class="detail" id="fund-cate-detail">
            <p *ngIf="riskLevelName ===  'ความเสี่ยงต่ำ' || riskLevelName ===  'Low Risk'">{{title}}</p>
            <p *ngIf="riskLevelName ===  'ความเสี่ยงปานกลาง' || riskLevelName ===  'Moderate Risk'">{{title}}</p>
            <p *ngIf="riskLevelName ===  'ความเสี่ยงสูง' || riskLevelName ===  'High Risk'">{{title}}</p>
        </div>
    </section>
    <section class="fund-risk--detail">
        <div class="row">
            <ng-container [ngSwitch]="true">
                <ng-container *ngSwitchCase="riskLevelName ===  'ความเสี่ยงต่ำ'  || riskLevelName ===  'Low Risk'">
                    <div class="col-12 col-md-12 col-lg-6 col-xl-6">
                        <div style="width: 100%;">
                            <div id="container" class="pie-chart" [chart]="donut"></div>
                        </div>
                        <section class="summary-investment">
                            <section class="group-section">
                                <h4 class="title">{{language.fundriskdetailtitle1}}
                                    <span>*</span>
                                </h4>
                                <ul class="list-unstyled list-investment">
                                    <li>
                                        <span>{{riskDetail1_1}}</span>
                                        <span class="avg-percent">{{riskDetail1_1P}}</span>
                                    </li>
                                    <li>
                                        <span>{{riskDetail1_2}}</span>
                                        <span class="avg-percent">{{riskDetail1_2P}}</span>
                                    </li>
                                </ul>
                            </section>
                            <section class="group-section">
                                <ul class="list-unstyled list-investment">
                                    <li>
                                        <span class="h4 title">{{language.fundriskdetailtitle2}}</span>
                                        <span class="avg-percent">{{riskDetail2p}}</span>
                                    </li>
                                </ul>
                            </section>
                            <section class="group-section">
                                <h4 class="title">{{language.fundriskdetailtitle3}}
                                    <span>*</span>
                                </h4>
                                <ul class="list-unstyled list-investment">
                                    <li>
                                        <span>{{riskDetail3_1}}</span>
                                        <span class="avg-percent">{{riskDetail3_1P}}</span>
                                    </li>
                                    <li>
                                        <span>{{riskDetail3_2}}</span>
                                        <span class="avg-percent">{{riskDetail3_2P}}</span>
                                    </li>
                                </ul>
                            </section>
                        </section>
                    </div>
                    <div class="col-12 col-md-12 col-lg-6 col-xl-6">
                        <section class="summary-recommend">
                            <div class="info">
                                <ul class="list-unstyled list-fund">
                                    <li *ngIf="fundList1">
                                        <span class="title-cat -green_dark">{{language.fundriskdetailtitle4}} {{p1}}</span>
                                        <span class="text">{{language.menu2box5}}</span>
                                        <ul class="list-unstyled list-inline list-feature">
                                            <div class="list-item" *ngFor="let item of fundList1">
                                                <a [routerLink]="['/fund/detail/',item.fundid,item.Currency]" style="text-decoration: none;">
                                                    <app-button [outline]="true" text="{{item.fundCode}}"></app-button>
                                                </a>
                                            </div>
                                        </ul>
                                    </li>
                                    <li *ngIf="fundList2">
                                        <span class="title-cat -green">{{language.fundriskdetailtitle5}} {{p2}}</span>
                                        <span class="text">{{language.menu2box5}}</span>
                                        <ul class="list-unstyled list-inline list-feature">
                                            <div class="list-item" *ngFor="let item of fundList2">
                                                <a [routerLink]="['/fund/detail/',item.fundid,item.Currency]" style="text-decoration: none;">
                                                    <app-button [outline]="true" text="{{item.fundCode}}"></app-button>
                                                </a>
                                            </div>
                                        </ul>
                                    </li>
                                    <li *ngIf="fundList3">
                                        <span class="title-cat -orange">{{language.fundriskdetailtitle6}} {{p3}}</span>
                                        <span class="text">{{language.menu2box5}}</span>
                                        <ul class="list-unstyled list-inline list-feature">
                                            <div class="list-item" *ngFor="let item of fundList3">
                                                <a [routerLink]="['/fund/detail/',item.fundid,item.Currency]" style="text-decoration: none;">
                                                    <app-button [outline]="true" text="{{item.fundCode}}"></app-button>
                                                </a>
                                            </div>
                                        </ul>
                                    </li>
                                    <li *ngIf="fundList4">
                                        <span class="title-cat -orange_dark">{{language.fundriskdetailtitle7}} {{p4}}</span>
                                        <span class="text">{{language.menu2box5}}</span>
                                        <ul class="list-unstyled list-inline list-feature">
                                            <div class="list-item" *ngFor="let item of fundList4">
                                                <a [routerLink]="['/fund/detail/',item.fundid,item.Currency]" style="text-decoration: none;">
                                                    <app-button [outline]="true" text="{{item.fundCode}}"></app-button>
                                                </a>
                                            </div>
                                        </ul>
                                    </li>
                                    <li *ngIf="fundList5">
                                        <span class="title-cat -orange_dark2">{{language.fundriskdetailtitle8}} {{p5}}</span>
                                        <span class="text">{{language.menu2box5}}</span>
                                        <ul class="list-unstyled list-inline list-feature">
                                            <div class="list-item" *ngFor="let item of fundList5">
                                                <a [routerLink]="['/fund/detail/',item.fundid,item.Currency]" style="text-decoration: none;">
                                                    <app-button [outline]="true" text="{{item.fundCode}}"></app-button>
                                                </a>
                                            </div>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </section>
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="riskLevelName ===  'ความเสี่ยงปานกลาง' || riskLevelName ===  'ความเสี่ยงสูง'  || riskLevelName ===  'Moderate Risk' || riskLevelName ===  'High Risk'">
                    <div class="col-12 col-md-12 col-lg-6 col-xl-6">
                        <div style="width: 100%;">
                            <div id="container" class="pie-chart" [chart]="donut"></div>
                        </div>
                        <section class="summary-investment">
                            <section class="group-section">
                                <h4 class="title">{{language.fundriskdetailtitle1}}
                                    <span>*</span>
                                </h4>
                                <ul class="list-unstyled list-investment">
                                    <li>
                                        <span>{{riskDetail1_1}}</span>
                                        <span class="avg-percent">{{riskDetail1_1P}}</span>
                                    </li>
                                    <li>
                                        <span>{{riskDetail1_2}}</span>
                                        <span class="avg-percent">{{riskDetail1_2P}}</span>
                                    </li>
                                </ul>
                            </section>
                            <section class="group-section">
                                <ul class="list-unstyled list-investment">
                                    <li>
                                        <span class="h4 title">{{language.fundriskdetailtitle2}}</span>
                                        <span class="avg-percent">{{riskDetail2p}}</span>
                                    </li>
                                </ul>
                            </section>
                            <section class="group-section">
                                <h4 class="title">{{language.fundriskdetailtitle3}}
                                    <span>*</span>
                                </h4>
                                <ul class="list-unstyled list-investment">
                                    <li>
                                        <span>{{riskDetail3_1}}</span>
                                        <span class="avg-percent">{{riskDetail3_1P}}</span>
                                    </li>
                                    <li>
                                        <span>{{riskDetail3_2}}</span>
                                        <span class="avg-percent">{{riskDetail3_2P}}</span>
                                    </li>
                                </ul>
                            </section>
                        </section>
                    </div>
                    <div class="col-12 col-md-12 col-lg-6 col-xl-6">
                        <section class="summary-recommend">
                            <div class="info">
                                <ul class="list-unstyled list-fund">
                                    <li *ngIf="fundList1">
                                        <span class="title-cat -green_dark">{{language.fundriskdetailtitle4}} {{p1}}</span>
                                        <span class="text">{{language.menu2box5}}</span>
                                        <ul class="list-unstyled list-inline list-feature">
                                            <div class="list-item" *ngFor="let item of fundList1">
                                                <a [routerLink]="['/fund/detail/',item.fundid,item.Currency]" style="text-decoration: none;">
                                                    <app-button [outline]="true" text="{{item.fundCode}}"></app-button>
                                                </a>
                                            </div>
                                        </ul>
                                    </li>
                                    <li *ngIf="fundList2">
                                        <span class="title-cat -green">{{language.fundriskdetailtitle5}} {{p2}}</span>
                                        <span class="text">{{language.menu2box5}}</span>
                                        <ul class="list-unstyled list-inline list-feature">
                                            <div class="list-item" *ngFor="let item of fundList2">
                                                <a [routerLink]="['/fund/detail/',item.fundid,item.Currency]" style="text-decoration: none;">
                                                    <app-button [outline]="true" text="{{item.fundCode}}"></app-button>
                                                </a>
                                            </div>
                                        </ul>
                                    </li>
                                    <li *ngIf="fundList3">
                                        <span class="title-cat -orange">{{language.fundriskdetailtitle6}} {{p3}}</span>
                                        <span class="text">{{language.menu2box5}}</span>
                                        <ul class="list-unstyled list-inline list-feature">
                                            <div class="list-item" *ngFor="let item of fundList3">
                                                <a [routerLink]="['/fund/detail/',item.fundid,item.Currency]" style="text-decoration: none;">
                                                    <app-button [outline]="true" text="{{item.fundCode}}"></app-button>
                                                </a>
                                            </div>
                                        </ul>
                                    </li>
                                    <li *ngIf="fundList4">
                                        <span class="title-cat -orange_dark">{{language.fundriskdetailtitle7}} {{p4}}</span>
                                        <span class="text">{{language.menu2box5}}</span>
                                        <ul class="list-unstyled list-inline list-feature">
                                            <div class="list-item" *ngFor="let item of fundList4">
                                                <a [routerLink]="['/fund/detail/',item.fundid,item.Currency]" style="text-decoration: none;">
                                                    <app-button [outline]="true" text="{{item.fundCode}}"></app-button>
                                                </a>
                                            </div>
                                        </ul>
                                    </li>
                                    <li *ngIf="fundList5">
                                        <span class="title-cat -blue">{{language.fundriskdetailtitle8}} {{p5}}</span>
                                        <span class="text">{{language.menu2box5}}</span>
                                        <ul class="list-unstyled list-inline list-feature">
                                            <div class="list-item" *ngFor="let item of fundList5">
                                                <a *ngIf="item.fundid!=''" [routerLink]="['/fund/detail/',item.fundid,item.Currency]" style="text-decoration: none;">
                                                    <app-button [outline]="true" text="{{item.fundCode}}"></app-button>
                                                </a>
                                            </div>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </section>
                    </div>
                </ng-container>

            </ng-container>



            <div class="col-12">
                <section class="section-assumption">
                    <div class="area-blog">
                        <p class="title">
                            <span>*</span>Assumption</p>
                        <span class="desc">{{language.assumptiontitle}}</span>
                        <ol class="list-assumption">
                            <li>{{language.assumptiondetail1}}</li>
                            <li>{{language.assumptiondetail2}}</li>
                            <li>{{language.assumptiondetail3}}</li>
                            <li>{{language.assumptiondetail4}}</li>
                            <li>{{language.assumptiondetail5}}</li>
                            <li>{{language.assumptiondetail6}}</li>
                        </ol>
                    </div>
                </section>
            </div>
        </div>
    </section>




</ng-template>